import * as types from './mutation-types'

export function userInit({commit, state}, user) {
  commit(types.SET_USER, user)
  /*let token = {
    tokenExpMillis: user.tokenExpMillis,
    authorizationToken: user.authorizationToken
  };
  commit(types.SET_TOKEN, token);*/
}



// WEBPACK FOOTER //
// ./src/store/actions.js